export default "__VITE_ASSET__BohaoBK8__"